import FormNewPassword from "./FormNewPassword";;
export default FormNewPassword;